//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../../api/common";
import imPrescription from "@/components/im/imPrescription/index.vue";
import { setTimeout } from 'timers';
export default {
    components: {
        imPrescription
    },
    data() {
        return {
            messageInfo: [], //历史聊天记录 操作值
            messageInfoshow: [], //历史聊天记录 显示值
            messages: {}, //父组件传入子组件存入的值(医生信息)
            userInfo: {}, //患者基本信息
            input: "",
            height: {
                height: ""
            }, //聊天内容样式
            menuHeight: 0, //底部菜单高度
            blurInput: false, //input是否获取焦点
            displayShow: false, //是否显示底部菜单
            isopen: false, //默认关闭
            voiceImgUrl: require("../../../assets/im/left-3@3x.png"), //语音显示图片
            voiceShow: false, //语音是否显示
            interval: null, //定时器
            isVoice: true, //是否播放语音
            voiceImgs: {}, //语音图片集合
            refreshs: "",
            index: 0,
            isshow: false,
            heightShow: "",
            getmessageinfo:true,
            isScroll:true,
            lastNum:''//剩余聊天次数,
        };
    },
    created() {
      document.title = this.$store.state.AllOfValue.ImDoctorInfo.doctorName?this.$store.state.AllOfValue.ImDoctorInfo.doctorName+"医生的对话":"复诊医生";
        var _this = this;
        this.userInfo = this.$store.state.userInfo;
        this.messages = this.$store.state.AllOfValue.ImDoctorInfo;
        if (this.messages != null && this.messages.doctorId != null) {
            var msgData = localStorage.getItem("msgsuccess") ? JSON.parse(localStorage.getItem("msgsuccess")) : {};
            var data = msgData[this.messages.doctorId];
            if (data != null && data.length > 0) {
                this.query(data, data.length, _this.messageInfo.length);
            }
        }
        this.$store.state.websocketdosome["onTextMessage"] = function(message) {
            if ( message.ext.businessType != null && message.ext.businessType != "" && (message.ext.businessType == "doctorEndOrder" || message.ext.businessType == "EndOrder")) {
                if (message.from == _this.messages.doctorId) {
                    _this.messages.isOrder = "2";
                    _this.$store.state.AllOfValue.ImDoctorInfo.isOrder = "2";
                }
            }
            _this.messageInfo.push(message);
            _this.getmessage();

        };
        this.$store.state.websocketdosome["onPictureMessage"] = function(message) {
            _this.messageInfo.push(message);
            _this.getmessage();
        };
        this.$store.state.websocketdosome["onAudioMessage"] = function(message) {
            _this.messageInfo.push(message);
            _this.getmessage();
        };
        this.$store.state.websocketdosome["onOffline"] = function() {
            _this.isshow = true;
        };
        this.$store.state.websocketdosome["onOpened"] = function() {
            _this.isshow = false;
        };
        _this.isDisturb();
        _this.getChatCounts();
    },
    mounted() {
      if(this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId){
        this.$loginout(this); //退出原有环信账号
        //就诊人登陆环信
        var userInfo={
          id:this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
        };
        var _this=this;
         setTimeout(function(){
           //若是登陆失败则重新登陆
           _this.$login(_this,userInfo);
         },100);
//        this.$login(this,userInfo);
      };
      this.$router.push({path: '/im'});
        this.heightTop();
        //ios 触发button后input不主动失焦
        //mousedown事件的默认行为是使除了你点击的对象之外的有焦点的对象失去焦点,所以只要在 mousedown 事件中阻止默认事件发生就可以了
        var btn = document.querySelector(".send-msg-py");
        if (btn) {
            btn.onmousedown = function(event) {
                event.preventDefault();
            };
        }

        //Android 在input获焦时，聊天内容不被遮挡
        var _this = this;
        var a = parseInt(this.height.height);
        window.onresize = function() {
            var heightTop = _this.$el.querySelector(".heightTop-py");
            _this.menuHeight = heightTop.offsetHeight;
            var b = window.innerHeight - _this.menuHeight - 44;
            _this.heightShow = b - a + "px";
        };

    },
    methods: {
      //是否免打扰
      isDisturb(){
        var _this = this;
        this.$doRequest(
          "/api/AppHomePage/Index",
          {
            parameters: _this.$store.state.AllOfValue.ImDoctorInfo.doctorId,
            twoParameter: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
          },
          res => {
            if(res.isNoDisturb==2&&(_this.messages.isOrder == '1'||_this.lastNum>0)){
              _this.$toastMsg("医生现在处于消息免到扰时段，时间段为"+res.noDisturb+"，医生会在上线后回复您");
            };
          })
      },
        //下拉加载数据，重新计算滚动条位置
        refresh(done) {
          //刷新后上下来回跳动的原因在于获取详情执行了scrollToBottom
            this.index++;
            var _this = this;
            _this.isScroll=false;
            //加载数据之前的聊天内容高度
            var oldheight = this.$refs.main.offsetHeight;

            var data = {
                userA :_this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
                userB:_this.$store.state.AllOfValue.ImDoctorInfo.doctorId
            }
            if(_this.getmessageinfo==true){
              _this.getmessageinfo=false;
            _this.$doRequest("/api/ImUtil/getChatRecords", data,res=>{
              var msgDatas=res.parameters;
              var type="msgsuccess";
              var msgdatas = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : {};
              if (msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId]) {
                for(var j=0;j<msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId].length;j++){
                  if(msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId][j].id=='laqu'){
                    msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId].splice(j--,1);
                  }
                }
                var local = window.localStorage;
                local.setItem(type, JSON.stringify(msgdatas));
              }
              var msgData={
                "to":"","fromid":"","msg":"","types":"","type":"","ext":{},"time":"",body:{},id:""
              };
              var msgData1={
                "to":"","fromid":"","data":"","types":"","type":"","ext":{},"time":"",id:""
              };
              for(var i=0;i<msgDatas.length;i++){
                if(msgDatas[i].from==_this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId){
//                  可以循环判断每一天记录的id和本地第1条数据是否相等
                  msgData.type=msgDatas[i].payload.bodies[0].type;
                  msgData.id='laqu';
                  msgData.fromid=_this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId;
                  msgData.to=msgDatas[i].to;
                  msgData.msg=msgDatas[i].payload.bodies[0].msg;
                  msgData.types=msgDatas[i].payload.bodies[0].type;
                  msgData.ext=msgDatas[i].payload.ext;
                  msgData.body.msg=msgDatas[i].payload.bodies[0].msg;
                  msgData.body.type=msgDatas[i].payload.bodies[0].type;
                  msgData.time=msgDatas[i].timestamp;
                  msgData.isRead=true;
                  var type="msgsuccess";
                  var msgdatas = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : {};
                  if (msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId]) {
                    msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId].unshift(msgData);
                  }
//                  else {
//                    var arr = [];
//                    arr.unshift(msgData);
//                    msgdatas[doctorId] = arr;
//                  }
                  var local = window.localStorage;
                  local.setItem(type, JSON.stringify(msgdatas));
                }else if(msgDatas[i].from==_this.$store.state.AllOfValue.ImDoctorInfo.doctorId){
                  msgData1.type=msgDatas[i].chat_type;
                  msgData1.id='laqu';
                  msgData1.from=msgDatas[i].from;
                  msgData1.to=msgDatas[i].to;
                  msgData1.data=msgDatas[i].payload.bodies[0].msg;
                  msgData1.types=msgDatas[i].payload.bodies[0].type;
                  msgData1.ext=msgDatas[i].payload.ext;
                  msgData1.time=msgDatas[i].timestamp;
                  msgData1.isRead=true;
                  var type="msgsuccess";
                  var msgdatas = localStorage.getItem(type) ? JSON.parse(localStorage.getItem(type)) : {};
                  if (msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId]) {
                    msgdatas[_this.$store.state.AllOfValue.ImDoctorInfo.doctorId].unshift(msgData1);
                  }
//                  else {
//                    var arr = [];
//                    arr.unshift(msgData1);
//                    msgdatas[doctorId] = arr;
//                  }
                  var local = window.localStorage;
                  local.setItem(type, JSON.stringify(msgdatas));
                }
              }
//              }
            });
            }

            var msgData = localStorage.getItem("msgsuccess") ? JSON.parse(localStorage.getItem("msgsuccess")) : {};
            var data = msgData[this.messages.doctorId];
            var datas = this.messageInfo;
            setTimeout(() => {
                _this.query(data, data.length, datas.length, () => {
                    setTimeout(() => {
                    //加载数据之后的聊天内容高度
                        var newheight = this.$refs.main.offsetHeight;
                        var heights = newheight - oldheight;
//                        this.$refs.myScroller.scrollTo(0, heights, true);  屏蔽是因为滚动条刷新上下移动
                    }, 500);
                });
                done();
            }, 500);
            setTimeout(()=>{
                _this.isScroll=true;
                console.log(_this.isScroll)
            },1000
            );

        },
        //input框获焦失焦就更新container置底
        updateHeight() {
            window.scroll(0, 0);
            this.scrollToBottom();
        },
        updateHeights() {
            var u = navigator.userAgent, app = navigator.appVersion;
            var isiOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(u);
            //兼容iPhoneX以上的input遮挡问题
            if (isiOS) {
                var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                //去除iphone6以下的机型
                if(width > 321){
                    window.setTimeout(function() {
                        window.scrollTo(0, document.body.clientHeight);
                    }, 100);
                }
            }
            this.scrollToBottom();
        },
        //初始化container的高度，并且置底
        heightTop() {
            var _this = this;
            var heightTop = this.$el.querySelector(".heightTop-py");
            this.menuHeight = heightTop.offsetHeight;
            this.height.height = window.innerHeight - this.menuHeight - 44 + "px";
            this.scrollToBottom();
        },
      //获取医生患者聊天次数
      getChatCounts() {
//        if(this.$store.state.AllOfValue.ImDoctorInfo.orderid){
          var _this = this;
          var data = {
            doctorId: this.$store.state.AllOfValue.ImDoctorInfo.doctorId,
            patientId: this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
//            orderId: this.$store.state.AllOfValue.ImDoctorInfo.orderid
          };
          this.$doRequest("/api/giveTalk/getSurplusTalkNum", data, res => {
            _this.lastNum=res.parameters.lastNum;
            _this.$store.state.lastNum=res.parameters.lastNum;
          });
//        }else{
//          this.$store.state.lastNum=0;
//        }

      },
        //获取的聊天数据进行格式化
        getmessage() {
            var _this = this;
            _this.getChatCounts();
            var uid = this.$imConn.getUniqueId();
            var datas = this.messageInfo;
            common.tryLock(this, "getmessage", uid, function() {
                try {
                    _this.getmessagedetail(datas, 0, uid, {});
                }catch (e) {
                    common.unLock(_this, "getmessage", uid);
                }
            });
        },

        getmessagedetail(datas, i, uid, updatalist) {
         var inquiryPatientId=this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId.toLowerCase();
         var datas1=datas.filter(datas => datas.fromid== inquiryPatientId || datas.to== inquiryPatientId);//过滤就诊人id
  var _this = this;
  if (i >= datas1.length) {
    var ids = _this.$imConn.getUniqueId();
    common.tryLock(_this, "msgdatas", ids, function() {
      try {
        var newList = localStorage.getItem("msgsuccess") ? JSON.parse(localStorage.getItem("msgsuccess")) : {};
        var list = newList[_this.messages.doctorId];
        list[list.length - 1].isRead = true;
        if (JSON.stringify(updatalist) != "{}") {
          for (var j = list.length - 1; j >= 0; j--) {
            if (list[j].ext.businessType != null && list[j].ext.businessType != "" && list[j].ext.businessType == "doctor_prescription" && list[j].ext.businessBody.paystate == 1 && list[j].ext.businessBody.orderstate != 4) {
              if (updatalist[list[j].ext.businessBody.id] != null) {
                list[j].ext.businessBody.paystate = updatalist[list[j].ext.businessBody.id].ext.businessBody.paystate;
                list[j].ext.businessBody.orderstate = updatalist[list[j].ext.businessBody.id].ext.businessBody.orderstate;
                delete updatalist[list[j].ext.businessBody.id];
                if (JSON.stringify(updatalist) == "{}") {
                  break;
                }
              }
            }
          }
        }
        localStorage.setItem("msgsuccess", JSON.stringify(newList));
        _this.messageInfo = datas1;

        //通话时间处理
        datas1.forEach((item) => {
          if(item.ext.businessBody){
            if(item.ext.businessBody.duration){
              let secondTime = parseInt(item.ext.businessBody.duration);
              let minuteTime = 0;//分
              let hourTime = 0;//小时
              let result = '';
              if(secondTime > 60) {
                minuteTime = parseInt(secondTime / 60);
                secondTime = parseInt(secondTime % 60);
                if(minuteTime > 60) {
                  hourTime = parseInt(minuteTime / 60);
                  minuteTime = parseInt(minuteTime % 60);
                }
                result = parseInt(secondTime);
                if(minuteTime > 0) {
                  result = parseInt(minuteTime)>9?parseInt(minuteTime):'0'+parseInt(minuteTime)+':' + result;
                }
                if(hourTime > 0) {
                  result = parseInt(hourTime)>9?parseInt(hourTime):'0'+parseInt(hourTime)+ ':' + result;
                }
              }else{
                result = '00:'+parseInt(secondTime);
              }
              item.ext.businessBody.duration = result;
            }
          }
        });
        _this.messageInfoshow = datas1;
        if(_this.isScroll==true){
          _this.scrollToBottom();
        }

      }catch (e) {
      }finally {
        common.unLock(_this, "msgdatas", ids);
        common.unLock(_this, "getmessage", uid);
      }
    });
  } else {
    var data = datas1[i];
    var isnew = true;
    var newyear = new Date().getFullYear();
    var newmouth = new Date().getMonth() + 1;
    var newday = new Date().getDate();
    var newtime = newyear + "-" + newmouth + "-" + newday + " 00:00:00";
    var newtimes = new Date(newtime).getTime();
    if (data.time > newtimes) {
      data.newdate = common.timestampToTime(data.time, 5);
    } else {
      data.newdate = common.timestampToTime(data.time, 1);
    }
    if (data.ext.businessType != null && data.ext.businessType != "" && data.ext.businessType == "EndOrder") {
      data.data = data.data.replace(/\\n/gm, "<br/>");
    }
    if (data.ext.businessType != null && data.ext.businessType != "" && data.ext.businessType == "doctorEndOrder") {
      data.data = "服务已结束<span style='display:block;font-size:12px;'>若有疑问<a href='tel:4006660101' style='color:#4DBFFF;text-decoration:underline'>联系客服</a></span>";
    }
    var from = data.from;
    var to = data.to;
    if (data.ext.sendReversal != null && data.ext.sendReversal != "" && data.ext.sendReversal == true) {
      data.from = to;
      data.to = from;
      data.msg = data.data;
    }
    if (data.ext.businessBody != null && JSON.stringify(data.ext.businessBody) != "{}") {
      if (data.ext.businessType != null && data.ext.businessType != "" && data.ext.businessType == "doctor_prescription" && data.ext.businessBody.paystate == "1" && data.ext.businessBody.orderstate != "4") {
        this.$doRequest({url: "/api/Inquiry/orderDetails",catchs: function(e) {
          _this.getmessagedetail(datas1, ++i, uid, updatalist);
        }},{getPrescriptionOrder: "1",prescriptionOrderId: data.ext.businessBody.id},function(res) {
          if (res.orderprescriptioninfos[0].paystate == 2 || res.orderprescriptioninfos[0].orderstate == 4) {
            data.ext.businessBody.paystate = res.orderprescriptioninfos[0].paystate;
            data.ext.businessBody.orderstate = res.orderprescriptioninfos[0].orderstate;
            updatalist[data.ext.businessBody.id] = data;
          }
          _this.getmessagedetail(datas1, ++i, uid, updatalist);
        },function(error){
          _this.getmessagedetail(datas1, ++i, uid, updatalist);
        });
      } else {
        this.getmessagedetail(datas1, ++i, uid, updatalist);
      }
    } else {
      this.getmessagedetail(datas1, ++i, uid, updatalist);
    }
  }
},
        query(array, totalPage, displayed, dosome) {
            var _this = this;
            var list = parseInt(totalPage) - parseInt(displayed);
            if (list > 10) {
                for (var i = list - 1; i >= list - 10; i--) {
                    _this.messageInfo.unshift(array[i]);
                }
            } else {
                for (var j = list - 1; j >= 0; j--) {
                    _this.messageInfo.unshift(array[j]);
                }
            }
            this.getmessage();
            if (dosome != null && typeof dosome == "function") {
                dosome();
            }
        },
        //发送文本消息
        enterSend() {
            var _this = this;
            if (this.input == "") {
                return false;
            }
            var input = this.input;
            var ext = {
                orderid: _this.messages.orderid
            };
            this.input = "";
            this.$sendPrivateText(_this,_this.messages.doctorId,input,function(msg) {
                _this.messageInfo.push(msg);
                _this.getmessage();
                var data = {
                    fromid: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
//                  fromid:_this.$store.state.userInfo.id,
                    toid: _this.messages.doctorId,
                    msgtype: "3",
                    val: input,
                    fromType: "2",
                  fromName: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientName,
//                    fromName: _this.$store.state.userInfo.patientnickname,
                    orderid: _this.messages.orderid
                };
                _this.$doRequest("/api/ImUtil/signIm", data, function(res) {
                });
            },ext);
        },
//      compressFile(file,callback) {
//        let fileObj = file;
//        let reader = new FileReader()
//        reader.readAsDataURL(fileObj) //转base64
//        reader.onload = function(e) {
//          let image = new Image() //新建一个img标签（还没嵌入DOM节点)
//          image.src = e.target.result
//          image.onload = function () {
//            let canvas = document.createElement('canvas'), // 新建canvas
//              context = canvas.getContext('2d'),
//              imageWidth = image.width / 2,    //压缩后图片的大小
//              imageHeight = image.height / 2,
//              data = ''
//            canvas.width = imageWidth
//            canvas.height = imageHeight
//            context.drawImage(image, 0, 0, imageWidth, imageHeight)
//            data = canvas.toDataURL('image/jpeg') // 输出压缩后的base64
//            let arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1], // 转成blob
//              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
//            while (n--) {
//              u8arr[n] = bstr.charCodeAt(n);
//            }
//            let files = new window.File([new Blob([u8arr], {type: mime})], 'test.jpeg', {type: 'image/jpeg'}) // 转成file
//            callback(files) // 回调
//          }
//        }
//      },
        //上传图片
        chooseImg(e) {
//          this.compressFile('chooseImgs');
            var _this = this;
            var ext = {
                orderid: _this.messages.orderid
            };
            this.$sendPrivateImg(_this,_this.messages.doctorId,"chooseImgs",function(msg) {
              console.log(msg,"收到消息")
                _this.messageInfo.push(msg);
                _this.getmessage();
                var data = {
                    fromid: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
                    toid: _this.messages.doctorId,
                    msgtype: "1",
                    fromType: "2",
                    fromName: _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientName,
//                    fromName: _this.$store.state.userInfo.patientnickname,
                    orderid: _this.messages.orderid,
                    //图片路径
                    filePath:msg.body.url
                };
                _this.$doRequest("/api/ImUtil/signIm", data, function(res) {
                });
            },ext);
        },
        //特殊聊天记录router处理
        routerToUpload(item) {
            if((item.ext.businessType == "inputSickInfo" || item.ext.businessType == "inputProfile" || item.ext.businessType == "uploadFacePic" || item.ext.businessType == "inputfollowInfo") && this.messages.isOrder == '2'&&this.lastNum<=0){
                this.$toastMsg('请购买在线复诊');
                return;
            }
            switch (item.ext.businessType) {
                case "inputSickInfo": //问诊资料模板
                    this.$router.push({
                        path: "/two",
                        query: { orderId: item.ext.orderid }
                    });
                break;
                case "patient_profile": //查看问诊资料
                    this.$router.push({
                        path: "/twos",
                        query: { orderId: item.ext.orderid }
                    });
                break;
                case "inputProfile": //问诊单模板
                    this.$router.push({
                        path: "/one",
                        query: { orderId: item.ext.orderid ,templaterId:item.ext.templaterId}
                    });
                break;
                case "profileFinish": //查看问诊单
                    this.$router.push({
                        path: "/ones",
                        query: { orderId: item.ext.orderid }
                    });
                break;
              case "inputfollowInfo": //随访单模板
                this.$router.push({
                  path: "/fives",
                  query: { orderId: item.ext.orderid,templaterId:item.ext.templaterId }
                });
                break;
              case "suifangFinish": //查看随访单
                this.$router.push({
                  path: "/fivex",
                  query: { orderId: item.ext.orderid }
                });
                break;
                case "uploadFacePic": //舌照面照模板
                    this.$store.state.AllOfValue.imuploadFacePic = {
                        isup: true,
                        orderid: item.ext.orderid,
                        doctorid: this.messages.doctorId
                    };
                    this.$router.push({
                        path: "/four"
                    });
                break;
                case "facePicFinish": //舌照面照查看
                    this.$store.state.AllOfValue.imuploadFacePic = {
                        isup: false,
                        orderid: item.ext.orderid,
                        doctorid: this.messages.doctorId
                    };
                    this.$router.push({
                        path: "/four"
                    });
                break;
                case "doctor_prescription": //医生开方
                    this.$store.state.AllOfValue.imuploadFacePic = {
                        isup: false,
                        orderid: item.ext.orderid,
                        doctorid: this.messages.doctorId
                    };
                    this.$router.push({
                        path: "/myOrderDetailsYF",
                        query: { id: item.ext.businessBody.id }
                    });
                break;
                case "buyMedicineRemindSuccessfully": //购药成功
                    this.$store.state.AllOfValue.imuploadFacePic = {
                        isup: false,
                        orderid: item.ext.orderid,
                        doctorid: this.messages.doctorId
                    };
                    this.$router.push({
                        path: "/myOrderDetailsYF",
                        query: { id: item.ext.businessBody.id }
                    });
                break;
            }
        },
        //滚动条置底
        scrollToBottom() {
            this.$nextTick(() => {
                var container = this.$refs.main.offsetHeight;
                setTimeout(() => {
                    this.$refs.myScroller.scrollBy(0, container, true);
                },160);
            });
        },
        //进入医生详情
        second() {
//            this.$router.push({ path: "/doctorDetails", query: { state: "g8t7r3" } });
            this.$router.push({ path: "/doctorDetails", query: { isbuy: "1" } });
//            this.$router.push({ path: "/buyServiceDetails"});
        },
        //进入我的病历
        routerTomedicine() {
            this.$router.push({ path: "/myOrderList", query: { source: "qy" } });
        },
        //播放语音
        playAudio(item, indexes) {
            var index = 0;
            var indexs = 0;
            var _this = this;
            try {
                _this.$set(_this.voiceImgs,{});
                clearInterval(_this.interval);
            } catch (error) {}
            this.interval = setInterval(function() {
                index++;
                indexs++;
                if (index > 3) {
                    index = 1;
                }
                _this.$set(_this.voiceImgs,indexes,require("../../../assets/im/left-" + index + "@3x.png"));
                if (indexs > item.length - 1) {
                    _this.$set(_this.voiceImgs, indexes, null);
                    clearInterval(_this.interval);
                }
            }, 1000);
            var bo = true;
            var audio = document.querySelectorAll("audio");
            var thisAudio = null;
            for(var j=0;j<audio.length;j++){
                if(audio[j].attributes.index.nodeValue == indexes){
                    thisAudio = audio[j];
                }
            }
            if(thisAudio == null)return;
            if (!thisAudio.paused) {
                bo = false;
            }
            for (var i = 0; i < audio.length; i++) {
                audio[i].pause();
                audio[i].currentTime = 0;
            }
            if (thisAudio.paused) {
                if (bo) {
                    thisAudio.play();
                } else {
                        clearInterval(_this.interval);
                    _this.$set(_this.voiceImgs,indexes,require("../../../assets/im/left-3@3x.png"));
                }
            } else {
                thisAudio.pause();
                clearInterval(_this.interval);
                 _this.$set(iceImgs,indexes,require("../../../assets/im/left-3@3x.png"));
            }
        },
        routerToMake(item) {
            this.$router.push({
                path: "/myOrderDetailsYF",
                query: { id: item.ext.businessBody.id }
            });
            this.$store.state.addressId=item.ext.businessBody.id;

        },
    },
    updated: function() {
        var _this = this;
        var heightTop = this.$el.querySelector(".heightTop-py");
        this.menuHeight = heightTop.offsetHeight;
    },
  destroyed: function() {
      var _this=this;
      var newtemp=JSON.parse(localStorage.getItem("temp"));
      if(newtemp!=null){
        newtemp.forEach(function(item1, index, arr) {
          if(item1 == _this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId) {
            arr.splice(index, 1);
          }
        });
        localStorage.removeItem("temp");
        localStorage.setItem("temp",JSON.stringify(newtemp));
      }
    },
    watch: {
        menuHeight: function(value, oldValue) {
            this.height.height = window.innerHeight - value - 44 + "px";
        },
        messageInfo: function(value, oldValue) {
            this.messageInfo = value;
        },
        messages: function(value, oldValue) {
            this.messages = value;
        },
        isshow: function(val, oldValue) {
            this.isshow = val;
        },
        heightShow: function(val, oldValue) {
            this.heightShow = val;
        },
        immediate: true
    }
};



// WEBPACK FOOTER //
// ./src/views/im/imMsg/index.vue